import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IB2BInquiry, IB2BInquiryInitialState } from "./b2bInquiryModel";
import { getAllB2BInquiries } from "./services/b2bInquiry.services";

const initialState: IB2BInquiryInitialState = {
  loading: false,
  error: "",
  B2BInquiryID: null,
  B2BInquiryList: [],
  FilterB2BInquiry: {
    Name: "",
    EmailID: "",
    MobileNo: "",
    CityName: "",
    ComponyName: "",
  },
};

const b2bInquirySlice = createSlice({
  name: "b2bInquiry",
  initialState,
  reducers: {
    setB2BInquiryID: (state, action) => {
      state.B2BInquiryID = action.payload;
    },
    clearB2BInquiryID: (state) => {
      state.B2BInquiryID = initialState.B2BInquiryID;
    },
    setFilterB2BInquiry: (state, action) => {
      state.FilterB2BInquiry = action.payload;
    },
    clearFilterB2BInquiry: (state) => {
      state.FilterB2BInquiry = initialState.FilterB2BInquiry;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllB2BInquiries.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllB2BInquiries.fulfilled,
      (state, action: PayloadAction<IB2BInquiry[]>) => {
        state.loading = false;
        state.B2BInquiryList = action.payload || [];
      },
    );
    builder.addCase(getAllB2BInquiries.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.B2BInquiryList = [];
    });
  },
});

export const { clearB2BInquiryID, setB2BInquiryID, clearFilterB2BInquiry,
  setFilterB2BInquiry, } = b2bInquirySlice.actions;
export default b2bInquirySlice.reducer;
